var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-checkbox',{attrs:{"id":'checkbox-' + _vm.item.id,"name":'checkbox-' + _vm.item.id,"value":true,"disabled":_vm.check_all},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }